import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../../../styles/detailStyles.css';
import './styles.css';

const Blog = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Blog component');
    }

    const [blogs, setBlogs] = useState([]);
    const [selectedBlog, setSelectedBlog] = useState(null);

    useEffect(() => {
        fetch('/data/blogs.json')
            .then(response => response.json())
            .then(data => {
                // Sort by ID descending and take top 3
                const sortedData = [...data].sort((a, b) => b.id - a.id).slice(0, 3);
                setBlogs(sortedData);
            })
            .catch(error => console.error('Error fetching blogs data:', error));
    }, []);

    const scrollToProjects = () => {
        const projectsSection = document.getElementById('projects');
        if (projectsSection) {
            projectsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const openModal = (blog) => {
        setSelectedBlog(blog);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedBlog(null);
        document.body.style.overflow = 'auto';
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };

        if (selectedBlog) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [selectedBlog]);

    return (
        <div className="mainArea transition-effect" id="blog-section">
            <div className="blog transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Blog Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Blogs
                            </div>

                            <img
                                src="/images/siteElements/scroll-up.png"
                                alt="Scroll Up Indicator"
                                className="blogScrollBoth"
                                onClick={scrollToProjects}
                            />
                        </div>

                        <div className="rightContent">
                            {blogs.length > 0 ? (
                                <>
                                    {blogs.map((blog) => (
                                        <div className="blogCard" key={blog.id} onClick={() => openModal(blog)}>
                                            <h3 className="blogTitle">{blog.title}</h3>
                                            <p className="blogSummary">{blog.summary}</p>
                                            <div className="blogMeta">
                                                <span className="blogDate">{blog.date}</span>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="blogViewMoreContainer">
                                        <Link to="/blogs" className="blogViewMoreLink">
                                            View More <i className="fa-solid fa-arrow-right"></i>
                                        </Link>
                                    </div>
                                </>
                            ) : (
                                <div className="comingSoonContainer">
                                    <div className="comingSoonCard">
                                        <h2 className="comingSoonTitle">Blog Coming Soon</h2>
                                        <p className="comingSoonText">
                                            I'm currently working on some exciting content for my blog.
                                            Stay tuned for articles about web development, machine learning,
                                            UI/UX design, and my journey as a developer.
                                        </p>
                                        <p className="comingSoonText">
                                            Expected launch: August 2025
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Blog Right"
                        className="rightImg"
                    />
                </div>
            </div>

            {selectedBlog && (
                <div className="modalOverlay" onClick={closeModal}>
                    <div className="detailModalContent" onClick={(e) => e.stopPropagation()}>
                        <button className="detailModalClose" onClick={closeModal}>&times;</button>
                        <div className="detailModalHeader">
                            <h2 className="detailModalTitle">{selectedBlog.title}</h2>
                            <span className="detailModalDate">{selectedBlog.date}</span>
                        </div>
                        <div className="detailModalBody">
                            <p className="detailModalText">
                                {selectedBlog.content}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Blog;